module.exports = __webpack_public_path__ + "static/media/pic3.9c575d1c.jpg";